import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "../paymentSuccess/PaymentSuccess.css"; // reuse same styles for card consistency

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState<number>(10); // redirect after 10s

  // Countdown + redirect logic
  useEffect(() => {
    if (countdown === 0) {
      redirectToPlanselection(); // redirect to pricing page or retry
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  const redirectToPlanselection = () => {
    navigate("/planselection");
  };

  return (
    <div className="page-container">
      <div className="subscription-card">
        <h2 className="subscription-message error">
          Payment Failed ❌
        </h2>

        <div className="subscription-details">
          <h3 className="details-title">Transaction Details</h3>

          <div className="details-row">
            <span className="label">Status:</span>
            <span className="status-badge failed">Failed</span>
          </div>

          <div className="details-row">
            <span className="label">Date:</span>
            <span>{new Date().toLocaleDateString()}</span>
          </div>

          <p className="redirect-text">
            Redirecting to Plan Selection <strong>{countdown}</strong> seconds...
          </p>
          <button className="redirect-button" onClick={redirectToPlanselection}>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
